import { ReactNode } from 'react';

export enum SidePanelVariant {
  Left = 'left',
  Right = 'right',
}

export interface ISidePanelProps {
  variant: SidePanelVariant;
  children?: ReactNode;
}

export interface FiltersSidePanelProps {
  minHeight?: number;
}

export interface ISidePanelSize {
  defaultSize: number;
  minSize: number;
  maxSize: number;
}
